











import {Component, mixins} from 'nuxt-property-decorator';
import CategoriesListMixin from '../../node_modules/sitis-nuxt/lib/mixins/CategoriesListMixin';
import {CmsMetaMixin} from '~/node_modules/sitis-nuxt/lib/mixins/index';
import SPage from '~/components/page/SPage.vue';

@Component({
    components: {
        SPage
    },
})

export default class CatalogListPage extends mixins(
    CategoriesListMixin,
    CmsMetaMixin
) {
    breadcrumbs: { path: string; title: string }[] = [
        {path: "/", title: "Главная"},
        {path: this.$route.path, title: "Каталог"},
    ];

    get isJJ() {
        return this.$store.getters['local-settings/isJJ'];
    }

    get cmsPageId() {
        return this.isJJ ? 208 : 99;
    }
}
